import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=c2c3192a&scoped=true&"
import script from "./DurationInput.vue?vue&type=script&lang=js&"
export * from "./DurationInput.vue?vue&type=script&lang=js&"
import style0 from "./DurationInput.vue?vue&type=style&index=0&id=c2c3192a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c3192a",
  null
  
)

export default component.exports